import apiRequest from "../../../../../../../../utils/ApiRequest/apiRequest";

type SubUserDetailsT = {
  Email: string;
  Name: string;
  Storage: number;
};

/**
 * Retrieves the details of a sub user based on the provided email.
 * @param subUserEmail - The email of the sub user.
 * @returns A promise that resolves to the sub user details, or undefined if an error occurs.
 */
const getSubUserDetails = async (subUserEmail: string) => {
  try {
    const res = await apiRequest("SubUsers", "ReactGetSubUserShortData", {
      subUserEmail,
    });

    if ("data" in res) {
      return res.data as SubUserDetailsT;
    } else {
      return;
    }
  } catch (error) {
    console.error(error);
  }
};

export default getSubUserDetails;
